import { action, createAction, createCustomAction } from 'typesafe-actions'
import { ActionTypes } from './constants'
import { DataModalPayload, OpenModalPayload, UnlockCompletePayload } from './types'

export const openModal = createAction(
  ActionTypes.OPEN_MODAL,
  (action) => (payload: OpenModalPayload) => action(payload)
)

export const closeModal = createCustomAction(ActionTypes.CLOSE_MODAL, (type) => {
  return (name: string, origin?: string) => ({
    type,
    payload: { name },
    meta: { origin },
  })
})

export const setModalData = (payload: DataModalPayload) =>
  action(ActionTypes.SET_MODAL_DATA, payload)

export const unlockActivityCompleted = createAction(
  ActionTypes.UNLOCK_ACTIVITY_COMPLETED,
  (action) => (payload: UnlockCompletePayload) => action(payload)
)
